import InfoPage from "./InfoPage";

export default function About() {
  return (
    <InfoPage
      title="About Trescend"
      description="Trescend is a place to share ideas, see them evolve through community engagement, and enter free idea competitions for cash prizes."
    >
      <p>
        Trescend is a place to share ideas — and see the best ones rewarded.
        Post an idea publicly and let the community respond, or submit it to
        one of our idea competitions for a chance to win a cash prize.
      </p>
      <p>
        Every public idea on Trescend can evolve. As other users engage with
        it, an idea moves through stages — Spark, Orbit, Gravity, Nova,
        Constellation — a visible record of how far it's traveled since it
        was first posted.
      </p>
      <p>
        Competitions are free to enter and judged on originality and merit.
        Submissions are evaluated by our own AI system together with human
        review, and winners are paid out directly to their Trescend wallet.
      </p>
      <p>
        We built Trescend because good ideas often go nowhere simply because
        no one sees them. Our goal is to give every idea a place to be seen,
        discussed, and — when it's good enough — paid for.
      </p>
      <p>
        Read more in our <a href="/terms" style={{ color: "#f5c542" }}>Terms of Use</a> and{" "}
        <a href="/privacy" style={{ color: "#f5c542" }}>Privacy Policy</a>, or reach out on our{" "}
        <a href="/contact" style={{ color: "#f5c542" }}>Contact page</a>.
      </p>
    </InfoPage>
  );
}

